import { CartInfoModel } from './checkout/cart-info-model';
import { PaymentChannelType } from './constant';
import { RoomConditionDto } from './products/product-room-detail.model';
import { SearchFormModel } from './search-form-model';

export class CartModel extends CartInfoModel {
  conditions: RoomConditionDto[];
  search: SearchFormModel;
  searchId: string;

  constructor(condition = [], search = undefined, searchId = null) {
    super();
    this.conditions = condition;
    this.search = search;
    this.searchId = searchId;
  }
}

export class CartMultipaymentDetail {
  creditCardAmount: number;
  mainChannel?: PaymentChannelType;
  additionalChannel?: PaymentChannelType;
  creditTermsAmount: CreditTermsAmount;
  availableBudget?: AvailableBudget;
  isLimitBudgetPerMonthPerYearBooker?: boolean;
  isLimitBudgetPerMonthPerYearCoBooker?: boolean;
  isMultipayment?: boolean;

  constructor(creditCardAmount: number, creditTermsBooker: number, creditTermsCoBooker?: number) {
    this.creditCardAmount = creditCardAmount;
    this.creditTermsAmount = new CreditTermsAmount(creditTermsBooker, creditTermsCoBooker);
  }
}

export class CreditTermsAmount {
  booker: number;
  coBooker: number;

  constructor(creditTermsBooker: number, creditTermsCoBooker?: number) {
    this.booker = creditTermsBooker;
    this.coBooker = creditTermsCoBooker;
  }
}

export class AvailableBudget extends CreditTermsAmount {
  totalAvailableBudget?: number;

  constructor(creditTermsBooker: number, creditTermsCoBooker?: number, totalAvailableBudget?: number) {
    super(creditTermsBooker, creditTermsCoBooker);
    this.totalAvailableBudget = totalAvailableBudget;
  }
}



// WEBPACK FOOTER //
// ./src/app/model/cart.model.ts